import { equals } from 'ramda'
import * as React from 'react'

export function useEditableDropdownMultiselect({
  value: currentSelectedValues,
  onValueChange,
  onEditFinish,
}: {
  value: string[]
  onValueChange: (newSelectedValues: string[]) => void
  onEditFinish: (newSelectedValues: string[]) => void
}) {
  const [localSelectedValues, setLocalSelectedValues] = React.useState<string[]>([])
  const [open, setOpen] = React.useState<boolean>(false)

  const handleValueChange = React.useCallback(
    (newSelectedValues: string[]) => {
      if (!open) {
        onValueChange(newSelectedValues)
      }

      setLocalSelectedValues(newSelectedValues)
    },
    [open, setLocalSelectedValues, onValueChange],
  )

  const handleOpenChange = React.useCallback(
    (newOpen: boolean) => {
      setOpen(newOpen)
      setLocalSelectedValues(currentSelectedValues)

      if (!newOpen) {
        onValueChange(localSelectedValues)

        if (localSelectedValues.length && !equals(currentSelectedValues.sort(), localSelectedValues.sort())) {
          onEditFinish(localSelectedValues)
        }
      }
    },
    [localSelectedValues, currentSelectedValues, onValueChange, onEditFinish],
  )

  return {
    value: open ? localSelectedValues : currentSelectedValues,
    open,
    onOpenChange: handleOpenChange,
    onValueChange: handleValueChange,
  }
}
